<div class="tab-pane" role="tabpanel" id="step2">
    <div *ngIf="showFormIframe">
      <iframe
        #iframeFromView
        style="border: 0; border: none; width: 90%; height: 350px"
        [src]="urlSafe"
      ></iframe>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="unsetActiveFormInView()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div *ngIf="!showFormIframe" class="text-center">
      <form>
        <div class="text-center">
          <br />
          <small
            class="text-muted"
            [innerHTML]="
              'CARDOPERATIONS_ONLINE_CHARGE_INFORMATION_LABEL1'
                | translate
            "
          ></small>
          <br />
          <label class="pageMaxLabels">{{ viewParams.queryAlias }}</label>
          <br />
          <small
            class="text-muted"
            [innerHTML]="
              'CARDOPERATIONS_ONLINE_CHARGE_INFORMATION_LABEL2'
                | translate
            "
          ></small>
          <br />
          <label class="pageMaxLabels"
            >{{ viewParams.selectedChargeAmount }}
            {{ apiSettings.city.currency }}</label
          >
          <br />
          <small
            class="text-muted"
            [innerHTML]="
              'CARDOPERATIONS_ONLINE_CHARGE_INFORMATION_LABEL3'
                | translate
            "
          ></small>
          <br />
          <label class="pageMaxLabels"
            >{{ viewParams.selectedChargeCommissionAmount }}
            {{ apiSettings.city.currency }}</label
          >
          <br />
          <small
            class="text-muted"
            [innerHTML]="
              'CARDOPERATIONS_ONLINE_CHARGE_INFORMATION_LABEL4'
                | translate
            "
          ></small>
          <br />
          <br />
          <small
            class="text-muted"
            [innerHTML]="
              'CARDOPERATIONS_ONLINE_CHARGE_INFORMATION_LABEL5'
                | translate
            "
          ></small>
          <br />
          <label class="pageMaxLabels"
            >{{ viewParams.selectedChargeTotalAmount }}
            {{ apiSettings.city.currency }}</label
          >
          <br />
          <small
            class="text-muted"
            [innerHTML]="
              'CARDOPERATIONS_ONLINE_CHARGE_INFORMATION_LABEL6'
                | translate
            "
          ></small>
          <div class="spacer30"></div>
        </div>
      </form>
      <div>
        <div>
          <label>
            <input
              type="checkbox"
              value="form1"
              class="regular-checkbox"
              [checked]="isChargeForm1Checked"
              (change)="
                onlineCharge_onTermsAndConditionChanged(
                  $event.target.value
                )
              "
            />
            <a
              class="rechargeTermConditionsBtn"
              (click)="setActiveFormInView('form1')"
              [innerHTML]="
                'CARDOPERATIONS_ONLINE_CHARGE_PRELIMINARY_TEXT_LABEL'
                  | translate
              "
            ></a>
            <span class="cr"><i class="cr-icon"></i></span>
            {{
              "CARDOPERATIONS_ONLINE_CHARGE_PRELIMINARY_TEXT_LABEL2"
                | translate
            }}</label
          >
          <br />
          <label>
            <input
              type="checkbox"
              value="form2"
              class="regular-checkbox"
              [checked]="isChargeForm2Checked"
              (change)="
                onlineCharge_onTermsAndConditionChanged(
                  $event.target.value
                )
              "
            />
            <a
              class="rechargeTermConditionsBtn"
              (click)="setActiveFormInView('form2')"
              [innerHTML]="
                'CARDOPERATIONS_ONLINE_CHARGE_TERMSCONDS_TEXT_LABEL'
                  | translate
              "
            ></a>
            <span class="cr"><i class="cr-icon"></i></span>
            {{
              "CARDOPERATIONS_ONLINE_CHARGE_TERMSCONDS_TEXT_LABEL2"
                | translate
            }}</label
          >
        </div>
      </div>
      <div class="spacer30"></div>
      <a
        type="submit"
        class="btn-primary center-block btn-lg icon icon-card2"
        (click)="onlineCharge_onChargeDetailClick()"
        [innerHTML]="
          'CARDOPERATIONS_ONLINE_CHARGE_CREDITCARD_BUTTON_LABEL'
            | translate
        "
      ></a>
    </div>
</div>